<template>
  <div class="container">
    <div class="tab-nav">
      <el-tabs v-model="activeName">
        <el-tab-pane label="待确认" name="/order/group/noConfirm"></el-tab-pane>
        <el-tab-pane
          label="已完成订单"
          name="/order/group/complete"
        ></el-tab-pane>
        <el-tab-pane label="无效订单" name="/order/group/invalid"></el-tab-pane>
      </el-tabs>
      <span class="prompt-text">当前收款账户：北京君乐联科技有限公司</span>
    </div>
    <div>
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: this.$route.path,
    };
  },
  watch: {
    activeName: {
      handler(val, ovl) {
        this.$router.push(val);
      },
    },
    $route(to, from) {
      //监听路由是否变化
      this.activeName = to.path;
      if (to.query.key != from.query.key) {
        this.activeName = to;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-nav {
  position: relative;

  .prompt-text {
    top: 0;
    right: 0;
    height: 40px;
    line-height: 40px;
    font-size: 0.875rem;
    position: absolute;
  }
}
</style>